import { render, staticRenderFns } from "./InlineDeleteIcon.vue?vue&type=template&id=67370b15&scoped=true"
var script = {}
import style0 from "./InlineDeleteIcon.vue?vue&type=style&index=0&id=67370b15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67370b15",
  null
  
)

export default component.exports